// Common properties for all events
const getCommonProperties = () => ({
	containerType: detectContainerType(),
	deviceType: detectDeviceType(),
	platform: detectPlatform(),
});

// Helper functions for common properties
const detectContainerType = () => {
	if (window.self !== window.top) return 'iframe';
	if (window.ReactNativeWebView) return 'webview';
	return 'browser';
};

const detectDeviceType = () => {
	const userAgent = navigator.userAgent.toLowerCase();
	if (/mobile|android|iphone|ipad|ipod/i.test(userAgent)) {
		return 'mobile';
	}
	return 'desktop';
};

const detectPlatform = () => {
	if (window.ReactNativeWebView) {
		const userAgent = window.navigator.userAgent.toLowerCase();
		return userAgent.includes('iphone') || userAgent.includes('ipad')
			? 'ios'
			: 'android';
	}
	return 'web';
};

export { getCommonProperties };
